import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useWalmartUrl = () => {
    const location = useLocation();

    return useMemo(() => {
        const searchParams = new URLSearchParams(location.search);
        const isWalmart = searchParams.get('walmart') === 'true';
        const specialityId = isWalmart ? searchParams.get('speciality') : null;

        return { isWalmart, specialityId };
    }, [location.search]);
};
